import { italic } from '@uiw/react-md-editor';
import React, { useState } from 'react';
export default function HTMLEditor(props) {
    const textAreaRef = React.useRef(null);
    const [isFocused, setIsFocused] = useState(false);
    const [cursorPosition, setCursorPosition] = useState(0);
    const updateCursorPosition = (e) => {
        if (textAreaRef.current) {
            const { selectionStart } = textAreaRef.current;
            setCursorPosition(selectionStart);
        }
    };
    
    const handleFocus = () => {
        setIsFocused(true);
    };
    const handleBlur = () => {
        setIsFocused(false);
    };
    
    const nextLine = () => {
        if(props.value?.length >= cursorPosition) {
            const newValue = props.value.slice(0, cursorPosition) + '<br/>' + props.value.slice(cursorPosition);
            props.onChange({ target: { value: newValue } });
            setCursorPosition(cursorPosition + 5);
        }else{
            alert('請在文字區域內點擊');
        }
    }
    const redirection = () => {
        if(props.value?.length >= cursorPosition) {
            const newValue = props.value.slice(0, cursorPosition) + ' <a target="_blank" clicktracking="off" href="https://" >顯示文字</a> ' + props.value.slice(cursorPosition);
            props.onChange({ target: { value: newValue } });
        }
    }
    const bold = () => {
        if(textAreaRef.current?.selectionStart !== textAreaRef.current?.selectionEnd && props.value) {
            const start = textAreaRef.current.selectionStart;
            const end = textAreaRef.current.selectionEnd;
            const selectedText = props.value.slice(start, end);
            const newValue = props.value.slice(0, start) + `<b>${selectedText}</b>` + props.value.slice(end);
            props.onChange({ target: { value: newValue } });
            setCursorPosition(start + 3); // Adjust cursor position after inserting <b> tag
        }else{
            alert('請選擇要加粗的文字');
        }
    }
    const italic = () => {
        if(textAreaRef.current?.selectionStart !== textAreaRef.current?.selectionEnd && props.value) {
            const start = textAreaRef.current.selectionStart;
            const end = textAreaRef.current.selectionEnd;
            const selectedText = props.value.slice(start, end);
            const newValue = props.value.slice(0, start) + `<i>${selectedText}</i>` + props.value.slice(end);
            props.onChange({ target: { value: newValue } });
            setCursorPosition(start + 3); // Adjust cursor position after inserting <i> tag
        }else{
            alert('請選擇要斜體的文字');
        }
    }
    const highlight = () => {
        if(textAreaRef.current?.selectionStart !== textAreaRef.current?.selectionEnd && props.value) {
            const start = textAreaRef.current.selectionStart;
            const end = textAreaRef.current.selectionEnd;
            const selectedText = props.value.slice(start, end);
            const newValue = props.value.slice(0, start) + `<mark>${selectedText}</mark>` + props.value.slice(end);
            props.onChange({ target: { value: newValue } });
            setCursorPosition(start + 6); // Adjust cursor position after inserting <mark> tag
        }else{
            alert('請選擇要標記的文字');
        }
    }
    return (
        <div className="w-full flex flex-col gap-[8px]">
            <textarea
                onKeyDown={(e) => {
                    updateCursorPosition(e);
                }}
                onClick={updateCursorPosition}
                onFocus={handleFocus} onBlur={handleBlur}
                ref={textAreaRef}
                onChange={props.onChange}
                className="w-full bg-[#FFFFFF80] border-[#8D876C] border-[1px] text-black p-[8px] rounded-[7px] min-h-[200px]"
                value={props.value}
            />
             <div className='flex flex-row items-center justify-start gap-[8px]'>
                <div className='text-[12px] font-[700] cursor-pointer text-[#0F737E] border-[1px] border-[#0F737E] rounded-[4px] px-[4px] py-[2px]' onClick={nextLine}>下一行符號</div>
                <div className='text-[12px] font-[700] cursor-pointer text-[#0F737E] border-[1px] border-[#0F737E] rounded-[4px] px-[4px] py-[2px]' onClick={redirection}>連結</div>
                <div className='text-[12px] font-[700] cursor-pointer text-[#0F737E] border-[1px] border-[#0F737E] rounded-[4px] px-[4px] py-[2px]' onClick={bold}>粗體</div>
                <div className='text-[12px] font-[700] cursor-pointer text-[#0F737E] border-[1px] border-[#0F737E] rounded-[4px] px-[4px] py-[2px]' onClick={italic}>斜體</div>
                <div className='text-[12px] font-[700] cursor-pointer text-[#0F737E] border-[1px] border-[#0F737E] rounded-[4px] px-[4px] py-[2px]' onClick={highlight}>標記文字</div>
                {/* {textAreaRef.current?.selectionStart} {textAreaRef.current?.selectionEnd}  */}
            </div>
        </div>
    )
}